import React from 'react'

import styles from './Tabs.module.css'

const TabMenu = ({ children }) => <ul className={styles.tabMenu}>{children}</ul>
export default TabMenu
